import { render, staticRenderFns } from "./PlanosPagamentos.vue?vue&type=template&id=6ba672ac"
import script from "./PlanosPagamentos.vue?vue&type=script&lang=js"
export * from "./PlanosPagamentos.vue?vue&type=script&lang=js"
import style0 from "./PlanosPagamentos.vue?vue&type=style&index=0&id=6ba672ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports